module.exports = __webpack_public_path__ + "img/stp_scan_blue.70d0fa9f.svg";